import React from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing"; 
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import theme from "./bioarray-theme";
import { CssBaseline } from "@mui/material";
import { ThemeProvider, createTheme, StyledEngineProvider } from "@mui/material/styles";
import { ThemeProvider as MuiStylesThemeProvider } from "@mui/styles";
import "./i18n/i18n";
import { SnackbarProvider } from 'notistack';

const URL =  process.env.REACT_APP_BACKEND_URL ?? ''

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_URL,
  release: process.env.REACT_APP_SENTRY_RELEASE,
  integrations: [new BrowserTracing(),
     Sentry.replayIntegration({
        maskAllText: false, 
     }),
  ], 
  tracesSampleRate: 1.0,
tracePropagationTargets: [
URL

],
 debug: true,
  sendDefaultPii: true,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0 
});

const container = document.getElementById("root") as HTMLElement
const root = createRoot(container)

root.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <MuiStylesThemeProvider theme={theme}>
          <CssBaseline />
          <SnackbarProvider
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            maxSnack={10}
          >
            <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </Sentry.ErrorBoundary>
          </SnackbarProvider>
        </MuiStylesThemeProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  </React.StrictMode>
);

reportWebVitals();
